import { Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { FileUploadEntry, FileUploadFilterInput } from 'app/api/file-upload.api.service';
import {
    FileUploadActionTypes,
    FileUploadLoaded,
    FileUploadRequested,
    FileUploadCancelled,
    FileUploadEntryCreateRequested,
    FileUploadEntryCreateCancelled,
    FileUploadEntryCreated,
    FileUploadEntryUpdateRequested,
    FileUploadEntryUpdateCancelled,
    FileUploadEntryUpdated
} from './file-upload.actions';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { LoadingState, CallState } from 'app/utils/callstate';

export interface FileUploadCall {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: FileUploadFilterInput;
    callState: CallState;
}

// tslint:disable-next-line: no-empty-interface
export interface FileUploadState extends EntityState<FileUploadEntry> {
    calls: Record<string, FileUploadCall>;
}

export const adapter: EntityAdapter<FileUploadEntry> = createEntityAdapter<
    FileUploadEntry
>({
    selectId: entry => entry.key
});
export const initialFileUploadState: FileUploadState = adapter.getInitialState({
    calls: {}
});

export function reducer(
    state = initialFileUploadState,
    action: Action
): FileUploadState {
    switch (action.type) {
        case FileUploadActionTypes.FileUploadRequested:
            const {
                companyId,
                key,
                filter
            } = (action as FileUploadRequested).payload;
            state.calls[companyId] = { companyId, key, filter, callState: LoadingState.Loading };
            return state;
        case FileUploadActionTypes.FileUploadLoaded:
            state.calls[(action as FileUploadLoaded).payload.companyId].callState = LoadingState.Loaded;
            return adapter.addMany((action as FileUploadLoaded).payload.fileUpload,
                {...state, action: Date.now()});
        case FileUploadActionTypes.FileUploadCancelled:
            state.calls[(action as FileUploadCancelled).payload.companyId].callState = {
                errorMessage: (action as FileUploadCancelled).payload.errorMessage
            };
            return state;
        case FileUploadActionTypes.FileUploadEntryCreateRequested:
                state.calls[(action as FileUploadEntryCreateRequested)
                    .payload.entry.companyId].callState = LoadingState.Loading;
                return state;
        case FileUploadActionTypes.FileUploadEntryCreated:
            const newEntry = (action as FileUploadEntryCreated).payload.entry;
            state.calls[newEntry.companyId].callState = LoadingState.Loaded;
            return adapter.addOne(newEntry, state);
        case FileUploadActionTypes.FileUploadEntryCreateCancelled:
            state.calls[(action as FileUploadEntryCreateCancelled).payload.entry.companyId].callState = {
                errorMessage: (action as FileUploadEntryCreateCancelled).payload.errorMessage
            };
            return state;
        case FileUploadActionTypes.FileUploadEntryUpdateRequested:
            state.calls[(action as FileUploadEntryUpdateRequested)
                .payload.entry.companyId].callState = LoadingState.Loading;
            return state;
        case FileUploadActionTypes.FileUploadEntryUpdated:
            const entry = (action as FileUploadEntryUpdated).payload.entry;
            state.calls[entry.companyId].callState = LoadingState.Loaded;
            return adapter.updateOne({id: entry.key, changes: entry}, state);
        case FileUploadActionTypes.FileUploadEntryUpdateCancelled:
            state.calls[(action as FileUploadEntryUpdateCancelled).payload.entry.companyId].callState = {
                errorMessage: (action as FileUploadEntryUpdateCancelled).payload.errorMessage
            };
            return state;
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
